import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const GlobalInquiryOfferCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لديك عروض جديدة لرؤية عالمية لديك`
          : `You have new offers for your global vision`
      }
    />
  )
}

export default GlobalInquiryOfferCover
